<script setup lang="ts">
import type { CSSProperties } from 'vue'

const props = withDefaults(
  defineProps<{
    reason?: string
    style?: CSSProperties
  }>(),
  {
    reason: 'Unable to render element.',
  },
)
</script>

<template>
  <span :style="props.style">⚠️ {{ props.reason }}</span>
</template>
